import * as React from 'react'

export const SearchConfig = () => {


    return <h1>search</h1>

}